module.exports = __webpack_public_path__ + "img/szjc12.9c6a46d2.png";